import React, { useEffect, useState } from "react";
import axios from "axios";

const AdminPix = () => {
  const [form, setForm] = useState({
    pixKey: "",
    merchantName: "",
    merchantCity: "",
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  const backend = import.meta.env.VITE_REACT_APP_BACKEND_BASEURL;

  const loadConfig = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const res = await axios.get(`${backend}/parametros/pix`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setForm({
        pixKey: res.data.pixKey || "",
        merchantName: res.data.merchantName || "",
        merchantCity: res.data.merchantCity || "",
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setMessage(
        err.response?.data?.message || "Erro ao carregar configuração do PIX"
      );
      console.error(err);
    }
  };

  useEffect(() => {
    loadConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!form.pixKey || !form.merchantName || !form.merchantCity) {
      setMessage("Preencha todos os campos obrigatórios.");
      return;
    }

    try {
      setSaving(true);
      const token = localStorage.getItem("token");
      await axios.put(`${backend}/parametros/pix`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMessage("Configuração PIX salva com sucesso.");
    } catch (err) {
      setMessage(
        err.response?.data?.message || "Erro ao salvar configuração do PIX"
      );
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">
        Parâmetros do PIX
      </h1>

      <div className="bg-white p-6 rounded-lg shadow">
        {loading ? (
          <div className="flex justify-center items-center h-24">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
        ) : (
          <form onSubmit={handleSave} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Chave PIX
              </label>
              <input
                type="text"
                name="pixKey"
                value={form.pixKey}
                onChange={handleChange}
                placeholder="e.g. +5511999999999, email@exemplo.com, CPF/CNPJ"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nome do Recebedor
                </label>
                <input
                  type="text"
                  name="merchantName"
                  value={form.merchantName}
                  onChange={handleChange}
                  placeholder="Nome da loja ou recebedor"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Cidade
                </label>
                <input
                  type="text"
                  name="merchantCity"
                  value={form.merchantCity}
                  onChange={handleChange}
                  placeholder="Cidade do recebedor"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            {message && (
              <div className="text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded p-2">
                {message}
              </div>
            )}

            <div className="flex gap-3">
              <button
                type="submit"
                disabled={saving}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
              >
                {saving ? "Salvando..." : "Salvar"}
              </button>
              <button
                type="button"
                onClick={loadConfig}
                className="px-4 py-2 bg-gray-100 text-gray-800 rounded hover:bg-gray-200"
              >
                Recarregar
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminPix;